import { render, staticRenderFns } from "./myOperationsixth.vue?vue&type=template&id=32c24fdd&scoped=true"
import script from "./myOperationsixth.vue?vue&type=script&lang=js"
export * from "./myOperationsixth.vue?vue&type=script&lang=js"
import style0 from "./myOperationsixth.vue?vue&type=style&index=0&id=32c24fdd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c24fdd",
  null
  
)

export default component.exports